export default {
  one: 'installments.one',
  'two-to-three': 'installments.two-to-three',
  'four-to-six': 'installments.four-to-six',
  'seven-to-nine': 'installments.seven-to-nine',
  'ten-to-twelve': 'installments.ten-to-twelve',
  'greater-than-twelve': 'installments.greater-than-twelve'
}
